import SupportTicketDictionary from "@/dictionary/SupportTicketDictionary";
import BaseModel from "./BaseModel";
import SupportReason from "./SupportReason";
import DateHandler from "@/composables/handlers/DateHandler";

/**
 * SupportTicket
 */
export default class SupportTicket extends BaseModel {
  constructor({
    id,
    uuid,
    name,
    user,
    user_name,
    user_email,
    course,
    course_title,
    reason,
    reason_name,
    message,
    status,
    closed_at,
    closed_by,
    closed_by_name,
    created_at,
    updated_at
  }) {
    super();

    this.id = id || null;
    this.uuid = uuid || null;
    this.name = name || null;
    this.user = user || null;
    this.user_name = user_name || null;
    this.user_email = user_email || null;
    this.course = course || null;
    this.course_title = course_title || null;
    this.reason = reason || null;
    this.reason_name = reason_name || null;
    this.message = message || null;
    this.status = status || 'open';
    this.closed_at = closed_at || null;
    this.closed_by = closed_by || null;
    this.closed_by_name = closed_by_name || null;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;

    if (this.reason && typeof this.reason === 'object') {
      this.reason = new SupportReason(this.reason);
    }

    this.dictionary = new SupportTicketDictionary();
  }

  /**
   * Returns true if ticket is open
   * @returns {Boolean}
   */
  isOpen() {
    return parseInt(this.status) === this.dictionary.OPEN;
  }

  /**
   * Returns true if ticket is in progress
   * @returns {Boolean}
   */
  isInProgress() {
    return parseInt(this.status) === this.dictionary.IN_PROGRESS;
  }

  /**
   * Returns true if ticket is closed
   * @returns {Boolean}
   */
  isClosed() {
    return parseInt(this.status) === this.dictionary.CLOSED;
  }

  /**
   * Returns translated status label
   * @returns {String}
   */
  getStatusLabel() {
    return this.dictionary.getLabel(this.status);
  }

  /**
   * Returns PrimeVue severity for status tag
   * @returns {String}
   */
  getStatusSeverity() {
    const severities = {
      [this.dictionary.OPEN]: 'warn',
      [this.dictionary.IN_PROGRESS]: 'info',
      [this.dictionary.CLOSED]: 'secondary'
    };
    return severities[this.status] || 'secondary';
  }

  /**
   * Returns formatted created_at date
   * @returns {String}
   */
  getCreatedAtDate() {
    return this.created_at ? DateHandler.format(this.created_at, 'DATETIME_SHORT') : null;
  }

  /**
   * Returns formatted closed_at date
   * @returns {String}
   */
  getClosedAtDate() {
    return this.closed_at ? DateHandler.format(this.closed_at, 'DATETIME_SHORT') : null;
  }

  /**
   * Returns the display name for the reason
   * @returns {String}
   */
  getReasonName() {
    if (this.reason && this.reason.name) return this.reason.name;
    return this.reason_name || 'Outro';
  }

  /**
   * Returns the display name for the user
   * @returns {String}
   */
  getUserName() {
    if (this.user && this.user.name) return this.user.name;
    return this.user_name || this.name || '-';
  }
}